import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// Logo configuration - Easy to adjust
const LOGO_CONFIG = {
  firstLogo: {
    src: "/assets/gujco-mall-logo.png",
    alt: "Gujco Logo",
    width: 140,
    height: 112,
  },
  secondLogo: {
    src: "/assets/international-coop.png",
    alt: "International Coop Logo",
    width: 140,
    height: 52,
  },
};

function Header({ colorCh }) {
  const navItems = [
    { title: "Home", url: "/" },
    { title: "About", url: "#about" },
    { title: "Products", url: "#Products" },
    { title: "Awards", url: "#awards" },
    { title: "Contact Us", url: "#contact" },
  ];

  const [colorChange, setColorchange] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavbarColor);
  }, []);

  const drawer = (
    <Box
      sx={{
        textAlign: "start",
        background: "#fff",
        height: "100%",
        width: 250,
      }}
    >
      {/* CLOSE BUTTON */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider />

      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <Link
              href={item.url}
              onClick={handleDrawerToggle}
              sx={{
                width: "100%",
                color: "#000",
                textDecoration: "none",
                px: 3,
                py: 1.5,
                fontWeight: 500,
                "&:hover": { color: "#778A24" },
              }}
            >
              <ListItemText primary={item.title} />
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <header style={{ position: "absolute", left: 0, width: "100%" }}>
      <AppBar
        component="nav"
        sx={{
          backgroundColor: "#fff",
          boxShadow: !colorChange && colorCh ? "block" : "none",
          color: "#000",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mx: { lg: 20 },
          }}
        >
          {/* LOGOS SIDE BY SIDE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* First Logo */}
            <img
              src={LOGO_CONFIG.firstLogo.src}
              alt={LOGO_CONFIG.firstLogo.alt}
              width={LOGO_CONFIG.firstLogo.width}
              height={LOGO_CONFIG.firstLogo.height}
              style={{ objectFit: "contain" }}
            />

            {/* Second Logo */}
            <img
              src={LOGO_CONFIG.secondLogo.src}
              alt={LOGO_CONFIG.secondLogo.alt}
              width={LOGO_CONFIG.secondLogo.width}
              height={LOGO_CONFIG.secondLogo.height}
              style={{ objectFit: "contain" }}
            />
          </Box>

          {/* MENU ICON */}
<IconButton
  aria-label="open drawer"
  edge="start"
  onClick={handleDrawerToggle}
  sx={{
    display: { lg: "none" },
    background: "#fff",
    mx: 2,             // ✅ equal margin left & right
    borderRadius: "8px",
  }}
>
  <MenuIcon sx={{ color: "#000" }} />
</IconButton>


          {/* NAVIGATION LINKS (Desktop Only) */}
          <Box sx={{ display: { xs: "none", lg: "block" } }}>
            {navItems.map((item, index) => (
              <Link
                href={item.url}
                key={index}
                sx={{
                  color: "#000",
                  padding: "0px 20px",
                  textDecoration: "none",
                  fontWeight: 500,
                  fontSize: "20px",
                  "&:hover": { color: "#778A24" },
                }}
              >
                {item.title}
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      {/* MOBILE DRAWER (Slides from left to right) */}
      <Drawer
        anchor="left" // 👈 slide from left
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
      >
        {drawer}
      </Drawer>
    </header>
  );
}

export default Header;
